import React from 'react';

const Work = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8">Work</h1>
      
      <div className="space-y-6 text-gray-800">
        {/* Add your work content here */}
        <p className="text-lg leading-relaxed">
          This page will showcase my professional work and projects.
        </p>
      </div>
    </div>
  );
};

export default Work; 